/** DI-01 — the "Deck summary (N bullets):" header and the G-9 truncation note around the bullets. */

import { deckSummaryBulletLabel, deckSummaryTruncationNote } from "../../../const";
import type { DeckSummaryMeta } from "../types";
import styles from "./DeckSummaryParts.module.css";

export function DeckSummaryHeader({ meta }: { readonly meta: DeckSummaryMeta }) {
  return (
    <p className={styles.header}>
      <strong>Deck summary</strong> {deckSummaryBulletLabel(meta.bulletCount)}:
    </p>
  );
}

/** Renders nothing unless the summary covers only part of the deck. */
export function DeckSummaryNote({ meta }: { readonly meta: DeckSummaryMeta }) {
  if (!meta.truncated) return null;
  return <p className={styles.note}>{deckSummaryTruncationNote(meta.slidesSummarised)}</p>;
}
